import { render, staticRenderFns } from "./RecessRequests.vue?vue&type=template&id=553bf702&scoped=true"
import script from "./RecessRequests.vue?vue&type=script&lang=js"
export * from "./RecessRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553bf702",
  null
  
)

export default component.exports